'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdStrikethroughS = function MdStrikethroughS(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.6 21.9c0 3 1.9 4.2 4.9 4.2 2 0 3.8-0.8 3.8-2.8 0-1.9-1-2.3-2.3-3-0.3-0.1-0.7-0.2-1-0.3h-16v-3.4h30v3.4h-6.5c0.1 0.2 0.3 0.4 0.3 0.5 0.3 0.8 0.6 1.8 0.6 2.8 0 3.6-2.4 5.4-5.3 6.2-1.1 0.3-2.2 0.5-3.6 0.5-0.7 0-1.6-0.1-2.4-0.2-1.7-0.4-3.1-0.9-4.3-1.8-1.8-1.3-3.1-3.1-3.1-6.1h4.9z m8.7-9.4c0-2.4-1.5-3.5-4-3.5-1.8 0-3.1 0.6-3.7 1.7-0.1 0.3-0.2 0.7-0.2 1.1 0 0.8 0.5 1.5 1.3 2 0.6 0.4 1.2 0.8 2.3 1.2h-7.7c0-0.2-0.2-0.2-0.3-0.4-0.4-0.8-0.6-1.7-0.6-2.8 0-2.2 1.2-3.9 2.5-4.9 1.6-1.1 3.7-1.9 6.5-1.9 2.7 0 5 0.8 6.5 2.1 1.3 1.2 2.4 3 2.4 5.4h-5z' })
        )
    );
};

exports.default = MdStrikethroughS;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/strikethrough-s.js
// module id = 2827
// module chunks = 0